var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertLightFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1455 12.793L11.8122 5.29297C11.3955 4.58464 10.6872 4.16797 9.89551 4.16797C9.10384 4.16797 8.39551 4.58464 7.97884 5.2513L3.64551 12.7513C3.22884 13.4596 3.22884 14.2513 3.64551 14.9596C4.06217 15.668 4.77051 16.0846 5.56218 16.0846H14.2288C15.0205 16.0846 15.7288 15.668 16.1455 15.0013C16.5205 14.293 16.5205 13.4596 16.1455 12.793ZM10.6038 13.2513H9.18718V12.0013H10.6038V13.2513ZM10.6038 11.168H9.18718V8.0013H10.6038V11.168Z",
    fill: "#FB4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertLightFilled);
export default __webpack_public_path__ + "static/media/icon_alert_light_filled.e5724df2.svg";
export { ForwardRef as ReactComponent };